import { render, staticRenderFns } from "./ventures-services.vue?vue&type=template&id=0555b642&scoped=true"
import script from "./ventures-services.vue?vue&type=script&lang=js"
export * from "./ventures-services.vue?vue&type=script&lang=js"
import style0 from "./ventures-services.vue?vue&type=style&index=0&id=0555b642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0555b642",
  null
  
)

export default component.exports